import { Maybe, PostPublishStatus } from '@/graphql/generated/types.generated';
import dayjs from 'dayjs';

export const postIsLocked = (post: {
    publishAt?: Maybe<string>;
    profiles?: Maybe<{ publishStatus: PostPublishStatus }[]>;
}): boolean => {
    return (
        dayjs(post.publishAt).diff(dayjs(), 'seconds') <= 30 ||
        (post.profiles || []).some((pp) => pp?.publishStatus === PostPublishStatus.Publishing)
    );
};
